var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SsoStepUpController',{attrs:{"errorMessage":_vm.errorMessage,"factors":_vm.factors,"mfaType":_vm.mfaType,"shouldHideEmailBadge":true},on:{"changeComponent":_vm.handleTooManyFailedAttempts,"resetErrorMessage":_vm.resetErrorMessage,"setErrorMessage":_vm.setErrorMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }